import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';

class Templates extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { trans } = this.props;
        return (
            <div>
                <Header trans={trans}
                    active="templates"
                    className="image-hero busines-2"
                    style={{backgroundImage: 'url(/static/images/temp-banner.jpg)'}}
                    title="Chatbot Templates"
                    body="Explore many templates for chatbot built professionally by the HansaBot team and other contributors Creating a chatbot has never been easier"
                />


















                <section className="author bg-light">
                    <div className="container">
                        <h3 className="section-title">
                            {trans('Choose a template')}
                        </h3>
                        <div className="row">
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/thumbnail.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Fashion Store Bot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">E-Commerce</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/stade.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Event/Conference Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Commercial</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/cars.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Car Dealerships Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Commercial</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/gym.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Gym/Fitness Club Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Health</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/contact.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Simple General Enquiry Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Local &amp; Small Business</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/meal.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Restaurant Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Commercial</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/worker.png)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Flower Shop Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Commercial</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/note.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Sales Coaches &amp; Trainers Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Education &amp; Coaching</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/singer.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Public Figures and Celebrities Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">News &amp; Media</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/teacher.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">E-learning Course Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Education &amp; Coaching</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/Business.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Webinar Chatbot for Business Coaches</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Education &amp; Coaching</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/sea.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Hotel Simple Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Commercial</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/book.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Book Writers and Authors Chatbot </span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">News &amp; Media</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/tables.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Simple Table Reservation Chatbot </span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Food &amp; Beverages</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/newspaper.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">News and Publications Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">News &amp; Media</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/doctor.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Generic Health Clinic </span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Health</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-4 col-lg-3 mb-5">
                                <div className="template-card">
                                    <div className="template-thumbnail" style={{backgroundImage: "url(/static/images/conversation.jpg)"}}>
                                        <div className="template-thumbnail--action">
                                            <a className="btn btn-sm btn-primary px-3 mx-3" href="#">More Detail</a>
                                        </div>
                                    </div>
                                    <div className="template-features">
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">cms</span>
                                        <span className="badge badge-pill badge-primary cursor-default ml-2">checkpoints</span>
                                    </div>
                                    <div className="template-detail">
                                        <h6 className="template-detail--name">
                                            <span className="d-inline-block font-weight-semibold text-truncate">Company Human Resource Chatbot</span>
                                            <span className="template-detail--price text-success ml-2">Free</span>
                                        </h6>
                                        <span className="text-muted">Generic</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="tags bg-white">
                    <div className="container">
                        <h3 className="section-title text-center">{trans('Browse Chatbot Templates By Tags')}</h3>
                        <div className="text-center">
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('flower')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('shop')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('ordering')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('services')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('customer support')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('lead')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('faq')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('inquiry')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('enquiry')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('form')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('contact')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('booking')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('hotel')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('acommodation')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('tutorial')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('car')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('business')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('showcase')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('appoinment')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('event')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('conference')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('keynote')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('restaurant')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('listing')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('location')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('menus')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('food')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('f&amp;b')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('fitness')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('gym')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('fitness club')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('training')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('shopping')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('store')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('fashion')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('e-commerce')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('clothes')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('contact-us')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('products')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('catalog')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('book')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('author')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('writer')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('biography')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('publishing')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('news')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('publication')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('publisher')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('media')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('broadcast')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('audience')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('education')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('e-learning')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('course')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('timetable')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('ebook')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('celebrity')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('coaching')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('influencer')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('subscribers')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('schedule')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('webinar')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('public figure')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('followers')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('fan')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('singer')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('company')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('hr')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('human resource')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('candidate')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('interview')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('job')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('resume')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('application')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('position')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('health')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('clinic')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('appointment')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('doctor')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('hospital')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('healthcare')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('patient')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('sales')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('trainer')}</a>
                            <a className="badge badge-pill badge-secondary mx-2" href="#">{trans('marketing')}</a>
                        </div>
                    </div>
                </section>











                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Templates);






// WEBPACK FOOTER //
// ./src/pages/Templates.js